import React, { useEffect, useState, useRef } from 'react';

const GetFlocoNotes = () => {
  const [htmlContent, setHtmlContent] = useState('');
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      const fetchHTML = async () => {
        try {
          const response = await fetch(
            'https://cloudlicensing-backend.deepseedsolutions.com/release/getrelease/latest',
          );
          /*const response = await fetch(
            'http://localhost:3001/release/getrelease/latest',
          );*/
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const json = await response.json();
          if (json) {
            const lastNote = json;
            //console.log("json",lastNote)
            if (lastNote && lastNote.notes) {
              setHtmlContent(lastNote.notes);
            } else {
              setHtmlContent('<p>Nenhuma nota encontrada.</p>');
            }
          } else {
            setHtmlContent('<p>Nenhum dado encontrado.</p>');
          }
        } catch (error) {
          console.error('Erro ao buscar HTML:', error);
          setHtmlContent('<p>Erro ao carregar o conteúdo.</p>');
        }
      };

      fetchHTML();
    }
  }, []);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </>
  );
};

export default GetFlocoNotes;
